module.exports = __webpack_public_path__ + "img/Group 1673.63ec36f1.png";